import React, { useState, useEffect, useMemo } from "react";
import { Button, Col, Input, Row, Select, Table } from "antd";
import useGet from "../../../global/hooks/useGet";
import { getModifiedResponse } from "../../../global/utils/responseModifier";
import { CheckCircleOutlined, SyncOutlined } from "@ant-design/icons";
import PaginationTable from "../../../global/components/paginationTable";

const columns = [
  // {
  //   title: "No",
  //   dataIndex: "LicenseNo",
  //   render: (text) => <div className="ml-3">{text}</div>,
  // },
  {
    title: "Name",
    dataIndex: "LicenseName",
    render: (text) => <div className="ml-3">{text}</div>,
  },
  // {
  //   title: "Product",
  //   dataIndex: "Product",
  //   render: (text) => <div className="ml-3">{text}</div>,
  // },
  {
    title: "Site Type",
    dataIndex: "SiteType",
    render: (text) => <div className="ml-3">{text}</div>,
  },
  {
    title: "Model",
    dataIndex: "Model",
    render: (text) => <div className="ml-3">{text}</div>,
  },
  {
    title: "Door",
    dataIndex: "Type",
    render: (text) => <div className="ml-3">{text}</div>,
  },
  // {
  //   title: "OEM",
  //   dataIndex: "OemNo",
  //   render: (text) => <div className="ml-3">{text}</div>,
  // },
];

const initialFilterState = {
  LicenseName: "",
  // Product: "",
  Model: "",
  // OemNo: "",
};

export const LicenseSelectForm = ({ setSelectedRow, type }) => {
  const [listData, setListData] = useState([]);
  const [filter, setFilter] = useState(initialFilterState);
  const [params, setParams] = useState({
    limit: 20,
    sort_by: "LicenseNo",
    order: "desc",
  });
  const modParams = { ...Object.fromEntries(Object.entries(params)) } || {};
  const initialPagination = {
    current: parseInt(modParams.page) || 1,
    pageSize: parseInt(modParams.limit) || 10,
    total: 0,
  };
  const [pagination, setPagination] = useState(initialPagination);

  // to get table data from API server
  const query = new URLSearchParams(params).toString();
  const licenseUrl = query
    ? `${process.env.REACT_APP_API_URL}/api/licenses/?${query}`
    : `${process.env.REACT_APP_API_URL}/api/licenses/`;
  const {
    data: licenseData,
    loading: licenseDataLoading,
    error: licenseDataError,
  } = useGet(licenseUrl);

  // console.log("licenseData", licenseData);
  const optionUrl = `${process.env.REACT_APP_API_URL}/api/licenses/options/`;

  const {
    data: optionData,
    loading: optionDataLoading,
    error: optionDataError,
  } = useGet(optionUrl);

  const [modifiedOptions, setModifiedOptions] = useState({
    products: [],
    models: [],
    oems: [],
  });
  const modifiedSiteTypes = getModifiedResponse(optionData, "sitetype");

  const originalOptions = useMemo(
    () => ({
      products: getModifiedResponse(optionData, "products") || [],
      models: getModifiedResponse(optionData, "models") || [],
      // oems: getModifiedResponse(optionData, "oems") || [],
    }),
    [optionData],
  );

  useEffect(() => {
    setModifiedOptions(originalOptions);
  }, [originalOptions]);

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRow(selectedRows);
    },
  };

  const onSearch = (value) => {
    console.log("search:", value);
  };

  const handleFilter = (e) => {
    const filterDict = {};
    for (const key in filter) {
      if (
        filter[key] !== null &&
        filter[key] !== "" &&
        filter[key] !== undefined
      ) {
        filterDict[key] = filter[key];
      }
    }
    const isEmpty = JSON.stringify(filterDict) === "{}";

    if (isEmpty) {
      return;
    } else {
      const params = {
        limit: 20,
        sort_by: "LicenseNo",
        order: "desc",
        ...filterDict,
      };
      setParams(params);
    }
  };

  const handleFilterChange = (e) => {
    const inputName = e.target.name;
    const inputValue = e.target.value.replace(/['""`''""]/g, "");
    setFilter({ ...filter, [inputName]: inputValue });
  };

  // useEffect(() => {
  //   if (data && !loading) {
  //     const newData = data?.data?.map((el) => ({
  //       ...el,
  //       key: el?.LicenseNo,
  //     }));
  //     setListData(newData);
  //   }
  // }, [data, loading]);

  useEffect(() => {
    if (licenseData && !licenseDataLoading) {
      // const filteredData = licenseData?.data?.filter(
      //   (item) => item?.LicenseType === type
      // );
      const newData = licenseData?.data?.map((el) => ({
        ...el,
        key: el?.LicenseNo,
      }));
      setListData(newData);
    }
  }, [licenseData, licenseDataLoading]);

  const paginationConfig = {
    current: pagination.current,
    pageSize: pagination.pageSize,
    total: licenseData?.count,
    showSizeChanger: true,
    pageSizeOptions: [10, 20, 50, 100],
    showTotal: (total, range) => `Total ${total} items ${range[0]}-${range[1]}`,
    onChange: (page, pageSize) => {
      setPagination({
        ...pagination,
        current: page,
        pageSize: pageSize,
      });

      const updatedParams = {
        ...params,
        limit: pageSize,
        page: page,
      };
      setParams(updatedParams);
    },
  };

  return (
    <div className="mt-3">
      <style>{`
        .license-select-table .ant-table-tbody .ant-table-measure-row > td {
          height: 0 !important;
          padding: 0 !important;
          border: 0 !important;
        }
      `}</style>
      <div className="mt-3 ">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Input
              className="input_text_3 mr10 !h-full"
              name="LicenseName"
              placeholder="Name"
              value={filter.LicenseName}
              onChange={handleFilterChange}
            />
          </Col>
          {/* <Col xs={24} sm={24} md={12} lg={8} xl={6}> */}
          {/* <Select
              showSearch
              placeholder="Product"
              optionFilterProp="Product"
              value={filter.Product || undefined}
              onChange={(value) => setFilter({ ...filter, Product: value })}
              onSearch={onSearch}
              options={modifiedOptions.products}
              style={{ width: "100%" }}
            /> */}
          {/* <Select
              showSearch
              allowClear
              placeholder="Product"
              optionFilterProp="Product"
              value={
                filter.Product?.toString() ? Number(filter.Product) : undefined
              }
              onChange={(value) => {
                setFilter({ ...filter, Product: value });
                // onSearch({ ...filter, ProductNo: value });
              }}
              onSearch={(value) => {
                // onFilterSearch("Product", value);
              }}
              options={modifiedOptions?.products}
              style={{ width: "100%" }}
            /> */}
          {/* </Col> */}
          <Col xs={24} sm={24} md={12} lg={6} xl={6}>
            <Select
              showSearch
              placeholder="Site Type"
              optionFilterProp="label"
              value={
                filter.SiteType || filter.SiteType === 0
                  ? Number(filter.SiteType)
                  : undefined
              }
              onChange={(value) => setFilter({ ...filter, SiteType: value })}
              onSearch={onSearch}
              options={modifiedSiteTypes}
              style={{ width: "100%" }}
              allowClear
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              showSearch
              allowClear
              placeholder="Model"
              optionFilterProp="Model"
              value={
                filter.Model?.toString() ? Number(filter.Model) : undefined
              }
              onChange={(value) => {
                setFilter({ ...filter, Model: value });
                // onSearch({ ...filter, ModelNo: value });
              }}
              onSearch={(value) => {
                // onFilterSearch("Model", value);
              }}
              options={modifiedOptions?.models}
              style={{ width: "100%" }}
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Input
              className="input_text_3 mr10 !h-full"
              name="Type"
              placeholder="Door"
              value={filter.Type}
              onChange={handleFilterChange}
            />
          </Col>

          {/* <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Input
              className="input_text_3 mr10 !h-full"
              placeholder="Site Type"
              value={filter.Type}
              onChange={handleFilterChange}
              name="Type"
            />
          </Col> */}
          {/* <Col xs={24} sm={24} md={12} lg={8} xl={6}>
            <Select
              showSearch
              placeholder="OEM"
              optionFilterProp="OemNo"
              value={filter.OemNo || undefined}
              onChange={(value) => setFilter({ ...filter, OemNo: value })}
              onSearch={onSearch}
              options={modifiedOems}
              style={{ width: "100%" }}
            />
          </Col> */}
        </Row>
      </div>

      <div className="my-4">
        <Button
          type="primary"
          onClick={handleFilter}
          className="mr-2 w-[104px] h-[32px]"
        >
          <CheckCircleOutlined />
          Apply
        </Button>
        <Button
          type="primary"
          className="w-[104px] h-[32px]"
          onClick={() => {
            setFilter(initialFilterState);
            setFilter({
              current: 1,
              pageSize: 10,
              total: 0,
            });
            setPagination({
              current: 1,
              pageSize: 10,
              total: 0,
            });
            // Define the new parameters for the API call
            const params = {
              limit: 10,
              sort_by: "LicenseNo",
              order: "desc",
            };

            setParams(params);
          }}
        >
          <SyncOutlined />
          Reset
        </Button>
      </div>
      <div className="flex flex-col min-h-0">
        <Table
          className="license-select-table"
          rowSelection={{
            type: "radio",
            ...rowSelection,
          }}
          columns={columns}
          dataSource={listData}
          pagination={false}
          scroll={{ y: 420 }}
        />
        {!optionDataLoading &&
          paginationConfig !== false &&
          paginationConfig?.total > 0 && (
            <div className="sticky bottom-0 bg-white pt-2">
              <PaginationTable
                total={paginationConfig.total}
                pagination={paginationConfig}
                paginationConfig={paginationConfig}
              />
            </div>
          )}
      </div>
    </div>
  );
};
